import http from '../config/http'
import router from '../router'
export default{
  // 客户经理登录
  userLogin ({commit}, sendMsg) {
    http.postQs('api/hsqh/wx/managerLogin', sendMsg.data, true)
      .then(res => {
        if (res.errorCode === 0 && res.data && res.data.sysUser) {
          // 登录成功
          let datas = res.data.sysUser || {}
          let returnUrl = sendMsg.returnUrl.redirect || '/'
          let userInfo = {
            ...datas,
            role: 'manager'
          }
          commit('SAVEUSER', userInfo)
          returnUrl = returnUrl + '&managerId=' + userInfo.userId
          router.replace({path: returnUrl})
        }
      })
  },
  // 客户登录
  customLogin ({commit}, sendMsg) {
    http.postQs('api/hsqh/wx/custLogin', sendMsg.data, true)
      .then(res => {
        if (res.errorCode === 0 && res.data) {
          // 登录成功
          let datas = res.data || {}
          let returnUrl = sendMsg.returnUrl.redirect || '/'
          let userInfo = {
            ...datas,
            role: 'custom'
          }
          commit('SAVEUSER', userInfo)
          router.replace({path: returnUrl})
        }
      })
  },
  // 用户中心自动登录
  autoLogin ({dispatch, commit}, data) {
    http.post('manager/tokenVerify/', data)
      .then(res => {
        if (res.code === 1000) {
          commit('SAVEUSER', data)
          dispatch('userInfos', {username: res.data.username})
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js